import React from 'react';
import KnowledgeCategoryContain from '../../Componant/Knowledgebase/KnowledgeCategory';

const KnowledgeCategory = () => {
  return (
    <div className='page-body'>
      <KnowledgeCategoryContain />
    </div>
  );
};

export default KnowledgeCategory;
